import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, RequireAuth } from './context/AuthContext';
import AuthCallback from './components/AuthCallback';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import Bayar from './pages/Bayar';
import Admin from './pages/Admin';
import Invitation from './pages/Invitation';
import AppLayout from './components/AppLayout';
import Beranda from './pages/Beranda';
import Checklist from './pages/Checklist';
import ChecklistDetail from './pages/ChecklistDetail';
import Anggaran from './pages/Anggaran';
import Undangan from './pages/Undangan';
import Profil from './pages/Profil';

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/inv/:slug" element={<Invitation />} />
      <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
      <Route path="/bayar" element={<RequireAuth><Bayar /></RequireAuth>} />
      <Route path="/admin" element={<RequireAuth admin><Admin /></RequireAuth>} />
      <Route path="/app" element={<RequireAuth paid><AppLayout /></RequireAuth>}>
        <Route index element={<Navigate to="/app/beranda" replace />} />
        <Route path="beranda" element={<Beranda />} />
        <Route path="checklist" element={<Checklist />} />
        <Route path="checklist/:categoryId" element={<ChecklistDetail />} />
        <Route path="anggaran" element={<Anggaran />} />
        <Route path="undangan" element={<Undangan />} />
        <Route path="profil" element={<Profil />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
